var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFirstPage = function SvgFirstPage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 19.04V4.96a.77.77 0 0 1 .095-.367.988.988 0 0 1 .271-.312 1.32 1.32 0 0 1 .406-.208 1.583 1.583 0 0 1 .956 0c.152.048.29.12.406.208a.98.98 0 0 1 .27.312.771.771 0 0 1 .096.367v14.08c0 .255-.132.499-.366.679-.235.18-.552.281-.884.281-.332 0-.65-.101-.884-.281-.234-.18-.366-.425-.366-.68zm4.635-7.674a1.537 1.537 0 0 0 .002 1.27c.09.199.222.377.386.521l7.45 6.554a1.234 1.234 0 0 0 1.63-1.853l-6.517-5.732a.169.169 0 0 1-.057-.126.168.168 0 0 1 .057-.126l6.516-5.732a1.234 1.234 0 0 0-1.63-1.853l-7.452 6.556a1.538 1.538 0 0 0-.385.521z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFirstPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "first-page.5791724f616ecb0455c4dab07d172031.svg";